import { Reducer } from 'redux';

import { TiptapEditorStoreActions, TiptapEditorStoreState } from '../tiptapEditorStoreTypes';

/**
 * Stores mounted editors as editor ID → instance. Editor IDs encode the owning
 * element, editor type, and context, so toolbar commands can target the exact
 * live Tiptap document without rebuilding a composite registry key.
 */
const tiptapEditorsByIdReducer: Reducer<TiptapEditorStoreState['editorsById'], TiptapEditorStoreActions> = (
    state = {},
    action,
) => {
    switch (action.type) {
        case 'REGISTER_TIPTAP_EDITOR':
            return {
                ...state,
                [action.editorId]: { instance: action.editor },
            };
        case 'UNREGISTER_TIPTAP_EDITOR': {
            if (state[action.editorId]?.instance !== action.editor) return state;

            const { [action.editorId]: removedEditor, ...remainingEditors } = state;
            return remainingEditors;
        }
        default:
            return state;
    }
};

export default tiptapEditorsByIdReducer;
